import Vue from 'vue';
import productResultInfos from './ProductsResultInfo';
import products from './Products';
import promotion, { PromotionStyle } from './Promotion';
import aboveProduct from './AboveProduct';
import belowProduct from './BelowProduct';
import { SmartSuggestV4 } from '../../../../declarations/request';

const productsContainer = Vue.component('fl-products-container', {
    template: `
        <div class="fl-w-100">
            <fl-above-product />
            <fl-promotion v-if="shouldContainPromotion" :promotion="promotion" />
            <fl-products-info :suggestionQuery="suggestionQuery" :totalResults="totalResults" :originalQuery="originalQuery"/>
            <fl-products :products="products" :class="{'fl-as-sdym-most-recent-products': usingFallbackProducts}" />
            <fl-below-product />
            <slot name="showAllResults"></slot>
        </div>`,
    data(): Record<string, any> {
        return {
            promotion: null,
            suggestionQuery: '',
            totalResults: 0,
            products: [],
            originalQuery: '',
            usingFallbackProducts: false,
        };
    },
    mounted(): void {
        this.requestService.onResultChangeWithFallback((result: SmartSuggestV4.Response, original: SmartSuggestV4.Response) => {
            this.$data.promotion = result.promotion;
            this.$data.suggestionQuery = result.effectiveProductSuggestionQuery;
            this.$data.products = result.products;
            this.$data.totalResults = result.totalResults;
            this.$data.originalQuery = this.HandleShopInteractionService.getActiveInputValue();

            this.$data.usingFallbackProducts = original?.products?.length === 0 && this.$data.products.length > 0;
        });
    },
    inject: ['config', 'HandleShopInteractionService', 'requestService'],
    components: {
        AboveProduct: aboveProduct,
        BelowProduct: belowProduct,
        ProductResultInfos: productResultInfos,
        Products: products,
        Promotion: promotion,
    },
    computed: {
        shouldContainPromotion(): boolean {
            return this.config.assistedSuggest.config.promotionStyle === PromotionStyle.ABOVE_PRODUCTS;
        },
    },
});

export default productsContainer;
